<template>
  <div>
    list
  </div>
</template>

<script setup>

</script>

<style scoped src="./index.css"></style>
